import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import TransferTabs from "../../components/transfer/transfer-tabs/TransferTabs";

const Transfer = () => {
  const userInfoData = useSelector(selectUser);

  return <TransferTabs userInfoData={userInfoData} />;
};

export default Transfer;
